import { render, staticRenderFns } from "./EventTabReport.vue?vue&type=template&id=4bb11e45&"
import script from "./EventTabReport.vue?vue&type=script&lang=js&"
export * from "./EventTabReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports